var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    {
      staticClass: "d-flex flex-column",
      attrs: { id: "annonce-add-reward-container" }
    },
    [
      _c(
        "div",
        {
          staticClass: "row pt-md-3 pt-2",
          attrs: { id: "annonce-add-reward-title-container" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 col-md-6 d-flex justify-content-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "custom-width ml-md-5 justify-content-between d-md-flex align-items-center"
                },
                [
                  _c("back-arrow", {
                    attrs: {
                      title: _vm.$t(
                        "annonce.create.additional.reward.page.title"
                      )
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row pt-md-5 pt-2",
          attrs: { id: "annonce-add-reward-sub-container" }
        },
        [
          _c(
            "div",
            {
              staticClass: "col-12 col-md-6 col-title",
              attrs: { id: "annonce-add-reward-sub-container-left" }
            },
            [
              _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                _c("span", { staticClass: "bold-text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("annonce.create.additional.reward.title"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                _c("h1", { staticClass: "content" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("annonce.create.additional.reward.description")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-width ml-md-5 mt-3" }, [
                _c(
                  "p",
                  {
                    staticClass: "link-main-color cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.$bvModal.show("additional-reward-info-modal")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("annonce.create.additional.reward.know.more")
                        )
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-6 d-flex justify-content-center justify-content-md-start",
              attrs: { id: "annonce-add-reward-sub-container-right" }
            },
            [
              _c("annonce-create-additional-reward-step", {
                attrs: {
                  annonce: this.annonce,
                  "need-to-disable-options": _vm.needToDisableOptions
                },
                on: { updateAnnonce: _vm.updateAnnonce }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer-annonce-add-reward" }, [
        _c("div", { staticClass: "row h-100" }, [
          _c(
            "div",
            {
              staticClass:
                "col-md-12 d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around"
            },
            [
              _c("div", { staticClass: "hide" }),
              _vm._v(" "),
              !_vm.hasValidatedSupplement
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: {
                        variant: "primary",
                        disabled:
                          _vm.isLoading ||
                          !_vm.hasSelectedAnOption ||
                          (_vm.hasSelectedAnOption &&
                            _vm.annonce.additionnalRewardLevel.value === null)
                      },
                      on: { click: _vm.validate }
                    },
                    [
                      !_vm.isLoading
                        ? _c("div", { staticClass: "pr-4 pl-4" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("Validate")) +
                                "\n            "
                            )
                          ])
                        : _c("b-spinner", { staticClass: "button-spinner" })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("AnnoncePaymentPromiseModal", {
        attrs: { "is-reward-edit": true },
        on: { close: _vm.closedPaymentModal, publish: _vm.handlePaymentSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62e1155b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e1155b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceAdditionnalRewardEdit.vue
// module id = 2Xoj
// module chunks = 0